import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'SALES_UPDATE',
    smsDelete : 'SALES_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        sales_summary: {},
        sales_operation_funnel: [],
        salesLoading: false,
        salesError: false,


        orderActionLoading : false,
        orderActionError : false,
        salesOrderNeedingAction : [],
        salesOrderNeedingActionPgCount : null,


        collectionRiskLoading : false,
        collectionRiskError : false,
        collectionRisks : [],
        collectionRiskCount : null,


        ...store
    },

    mutations : {
        ...mutations,

        SET_SALES_STATS (state, item) {
            state.sales_summary = item;
        },
        SET_OPERATION_FUNEEL (state, item) {
            state.sales_operation_funnel = item;
        },

        SALES_LOADING (state, loading) {
            state.salesLoading = loading;
        },

        SALES_ERROR (state, hasError) {
            state.salesError = hasError;
        },


        ORDER_ACTION_LOADING(state, loading) {
            state.orderActionLoading = loading;
        },

        ORDER_ACTION_ERROR(state, hasError) {
            state.orderActionError = hasError;
        },
        SET_SALES_ORDER_NEEDING_ACTION(state, {results, pg_count}) {
            state.salesOrderNeedingAction = results;
            state.salesOrderNeedingActionPgCount = pg_count;
        },

        COLLECTION_RISK_LOADING(state, loading) {
            state.collectionRiskLoading = loading;
        },

        COLLECTION_RISK_ERROR(state, hasError) {
            state.collectionRiskError = hasError;
        },
        SET_COLLECTION_RISKS(state, {results, pg_count}) {
            state.collectionRisks = results;
            state.collectionRiskCount = pg_count;
        }
    },


    actions: {
    
        async fetchSalesSummary({ commit }, payload) {
            commit('SALES_LOADING', true);
            commit('SALES_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_sales_summary, config);
                let response = result.data
                commit('SET_SALES_STATS', response.data);

            } catch(error) {
                commit('SALES_ERROR', true);
            }
            finally {
                commit('SALES_LOADING', false);
            }
        },

        async fetchSalesOperationFunnel({ commit }, payload) {
            commit('SALES_LOADING', true);
            commit('SALES_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_sales_operation_funnel, config);
                let response = result.data
                commit('SET_OPERATION_FUNEEL', response.data);

            } catch(error) {
                commit('SALES_ERROR', true);
            }
            finally {
                commit('SALES_LOADING', false);
            }
        },


        async fetchSalesOrderNeedingAction({ commit }, payload) {
            commit('ORDER_ACTION_LOADING', true);
            commit('ORDER_ACTION_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.count) params.append('count', payload.count);
               
                
                let url = V1API.get_sales_orders_needing_action + '?' + params.toString();
                let result = await axios.get(url, config);

                const {results,pg_count} = result.data
                commit('SET_SALES_ORDER_NEEDING_ACTION', {results,pg_count});
                
                return result.data

            } catch(error) {
                commit('ORDER_ACTION_ERROR', true);
            }
            finally {
                commit('ORDER_ACTION_LOADING', false);
        }
        
    },

    async fetchSalesCollectionRisk({ commit }, payload) {
            commit('COLLECTION_RISK_LOADING', true);
            commit('COLLECTION_RISK_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.count) params.append('count', payload.count);
                
                let url = V1API.get_sales_collection_risk + '?' + params.toString();
                let result = await axios.get(url, config);

                const {results,pg_count} = result.data
                commit('SET_COLLECTION_RISKS', {results,pg_count});
                
                return result.data

            } catch(error) {
                commit('COLLECTION_RISK_ERROR', true);
            }
            finally {
                commit('COLLECTION_RISK_LOADING', false);
        }
        
    }



    },

    getters: {}
}
